import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Users, Star, store } from "lucide-react";
import { Warehouse } from "lucide-react";
import { uiAlert } from "./alerts/customAlert/uiAlert";

/* const StoreCard = ({ storeCount, maxStore, name, address, image, warehouse = false, storeID, rating, followers }) => {
  const { count, queue } = useSelector((state) => state.offlineQueue);

  const navigate = useNavigate();
  return (
    <>
      <div className='storeCard warehouseCard'>
        <div>
          {queue.length > 0 && (queue.find((queueItem) => queueItem.storeID === storeID) ? <div className='notSyncDiv'>store not synced</div> : null)}
          <img
            onClick={
              warehouse
                ? () => navigate(`warehouse/${storeID}`)
                : () => {
                    //check if the user has reached the maximum number of stores

                    if (storeCount + 1 > maxStore) {
                      alert(`You subscription plan allows you to create only ${maxStore} stores. Please upgrade your plan to create more stores.`);

                      return;
                    }
                    navigate(`${name}/${storeID}`);
                  }
            }
            src={image}
          />
        </div>
        <p>{name}</p>
        <p>{address}</p>
        {!warehouse && (
          <div className='followStoreDiv'>
            <p>
              {" "}
              <BsPersonPlusFill /> {followers}
            </p>
            <p>
              {" "}
              <FaStar color='rgb(197, 194, 13)' /> {rating}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default StoreCard; */

const StoreCard = ({ storeCount, maxStore, name, address, image, warehouse = false, storeID, rating, followers }) => {
  const { count, queue } = useSelector((state) => state.offlineQueue);

  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        //check if the user has reached the maximum number of stores

        if (storeCount + 1 > maxStore) {
          uiAlert(`You subscription plan allows you to create only ${maxStore} stores. Please upgrade your plan to create more stores.`, "warning");

          return;
        }
        navigate(`${name}/${storeID}`);
      }}
      className='store-card-unique-component'
    >
      {queue.length > 0 && (queue.find((queueItem) => queueItem.storeID === storeID) ? <div className='notSyncDiv'>store not synced</div> : null)}
      <div className={`store-logo-container-unique`}>{image ? <img src={image} alt={`${name} logo`} className='store-image-unique' /> : <store />}</div>

      <h3 className='store-name-unique'>{name}</h3>
      <p className='store-address-unique'>{address}</p>

      <div className='store-stats-unique'>
        <div className='stat-item-unique'>
          <Users className='stat-icon-unique' />
          <span className='stat-number-unique'>{followers}</span>
        </div>

        <div className='star-rating-unique'>
          <Star className='star-icon-unique' />
          <span className='stat-number-unique'>{rating}</span>
        </div>
      </div>
    </div>
  );
};

export default StoreCard;

export const WarehouseCard = ({ name, address, image, warehouseID }) => {
  const { employee } = useSelector((state) => state.employee);
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        if (employee && !employee?.permissions.warehouse) {
          uiAlert("You don't have permission to access this warehouse", "error");
          return;
        }

        navigate(`warehouse/${warehouseID}`);
      }}
      className='warehouse-card-unique-component'
    >
      <div className={`store-logo-container-unique ${image ? "" : "warehouse-logo-unique"}`}>
        {image ? <img src={image} alt={`${name} image`} className='store-image-unique' /> : <Warehouse />}
      </div>

      <h3 className='store-name-unique'>{name}</h3>
      <p className='store-address-unique'>{address}</p>
    </div>
  );
};
